const Report = () =>
  import(/* webpackChunkName: "log-audit" */ '@/pages/log/audit/index.vue')

const Detail = () =>
  import(/* webpackChunkName: "log-audit" */ '@/pages/log/audit/detail.vue')

export default {
  path: 'audit',
  meta: { label: 'audit' },
  component: {
    name: 'AuditLog',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LogAuditReport',
      path: '',
      meta: { label: 'report' },
      component: Report
    },
    {
      name: 'LogDetailAudit',
      path: 'detail/:id',
      meta: { label: 'detail' },
      component: Detail,
      props: true
    }
  ]
}
